import LinkDropdown from './LinkDropdown';
import LinkItem from './LinkItem';
export const components = {
  LinkDropdown,
  LinkItem
};
flarum.reg.add('fof-links', 'forum/components', null);